import { trpc } from '@/data-loaders';

export const useSchoolParameters = (schoolId: number, year: number) => {
  return trpc.admin.getSchoolParameters.useQuery(
    { schoolId, year },
    {
      retry: false,
      cacheTime: 1000 * 60 * 60 * 24, // 1 day
      enabled: !!schoolId && !!year,
    },
  );
};
